import { ReactNode } from "react";
import { CommonAgentSummary } from "../types";
import AgentIcon from "../agent/AgentIcon";

export function formatCurrency(value: number) {
  return Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);
}

export function formatNumber(value: number) {
  return Intl.NumberFormat().format(value);
}

export function formatTimestamp(timestamp: number | null | undefined): string {
  if (timestamp == null) return "";

  return formatDate(new Date(timestamp * 1000));
}

export function formatDate(date: Date | null): string {
  if (date === null) return "";

  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
  };

  return date.toLocaleString("en-US", options);
}

export function formatMonthPrefix(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  return `${y}-${m}`;
}

export function currentMonthPrefix(): string {
  return formatMonthPrefix(new Date());
}

export function lastMonthPrefix(): string {
  const now = new Date();
  const first = new Date(now.getFullYear(), now.getMonth(), 1);
  first.setMonth(first.getMonth() - 1);
  return formatMonthPrefix(first);
}

export function getTimestampFromDateString(dateStr: string): number {
  return new Date(dateStr).getTime() / 1000;
}

export function getFriendlySource(source: string): string {
  if (source === "assistant") {
    return "behavior engine";
  } else if (source === "user") {
    return "game";
  } else {
    return source;
  }
}

export function getFriendlyAgentName(
  agent?: CommonAgentSummary | null
): string | null {
  return (agent && agent.friendly_name) || null;
}

export function getAgentLabel(agent?: CommonAgentSummary): ReactNode | null {
  if (!agent || !agent?.id) {
    return null;
  }

  const friendlyName = getFriendlyAgentName(agent);
  return (
    <div>
      <AgentIcon agent={agent} className="me-2" />
      {friendlyName ? <span>{friendlyName}</span> : <code>{agent.id}</code>}
    </div>
  );
}

export function convertStringToInt(value: string): number | null {
  const result = parseInt(value);
  return Number.isNaN(result) ? null : result;
}
